export const module = {
  info: {
    name: 'jikatel-rate-document',
    caption: 'Jikatel Rate Document'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Rate Document',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-rate-document->panel',
  }
}

export default module
